import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CustomPage } from '../models/custom-page';
import { CustomPageField } from '../models/custom-page-field';
import { Xaction } from '../models/xaction';
import { Product } from '../models/product';
import { Customer } from '../models/customer';
import { CustomPageGridRow } from '../models/custom-page-grid-row';
import { CustomPageGridRowId } from '../models/custom-page-grid-row-id';
import { SellerName } from '../models/seller-name';
import { FlatXactionCalculations } from '../models/flat-xaction-calculations';
import { CustomPageBatchItemChanges } from '../models/custom-page-batch-item-changes';
import { CoreResponse } from '../models/core-response';

@Injectable({
    providedIn: 'root'
})

export class CustomPageService {
    private baseurl: string = environment.apiEndpoint;
    private customPageURL = this.baseurl + '/customPage';

    constructor(private http: HttpClient) { }

    getFields(): Observable<any[]> {
        return this.http.get<any[]>(this.customPageURL + '/fields/');
    }

    getCustomPageLayout(): Observable<CustomPage[]> {
        return this.http.get<CustomPage[]>(this.customPageURL + '/customPage/');
    }

    getCustomPageLayoutById(id: number): Observable<CustomPage> {
        return this.http.get<CustomPage>(this.customPageURL + '/customPage/' + id);
    }

    getSelectedCustomPageFields(): Observable<CustomPageField[]> {
        return this.http.get<CustomPageField[]>(this.customPageURL + '/customPageFields');
    }

    getFilteredCustomPageItemRows(filterItem: CustomPageGridRow): Observable<FlatXactionCalculations[]> {
        return this.http.post<FlatXactionCalculations[]>(this.customPageURL + '/customPageFilteredDataSourceRows/', filterItem);
    }

    getDataSourceId(): Observable<number> {
        return this.http.get<number>(this.customPageURL + '/customPageDataSourceId');
    }

    getSelectableSellerNames(customPageId: number): Observable<SellerName[]> {
        return this.http.get<SellerName[]>(this.customPageURL + '/customPageSellerNames/' + customPageId);
    }

    insertCustomPageLayout(customPage: CustomPage): Observable<CustomPage> {
        return this.http.post<CustomPage>(this.customPageURL + '/customPage', customPage);
    }

    insertCustomPageItem(item: CustomPageGridRow): Observable<Xaction> {
        return this.http.post<Xaction>(this.customPageURL + '/insertItem', item);
    }

    updateCustomPage(customPage: CustomPage): Observable<any> {
        return this.http.put<CustomPage>(this.customPageURL + '/customPage', customPage);
    }

    updateCustomPageFields(customPageFields: CustomPageField[]): Observable<any> {
        return this.http.post<CustomPageField[]>(this.customPageURL + '/customPageFields', customPageFields);
    }

    deleteCustomPage(customPageId: number): Observable<CoreResponse<number>> {
        return this.http.delete<CoreResponse<number>>(this.customPageURL + '/customPage/' + customPageId);
    }

    batchResolveCustomPageItems(changes: CustomPageBatchItemChanges): Observable<CoreResponse<number>> {
        return this.http.post<CoreResponse<number>>(this.customPageURL + '/batchResolve', changes);
    }

    batchChangeCustomPageItems(changes: CustomPageBatchItemChanges): Observable<CoreResponse<boolean>> {
        return this.http.post<CoreResponse<boolean>>(this.customPageURL + '/batchItems', changes);
    }
}
